import {
  Box,
  //  Tab, TabList, TabPanel, TabPanels, Tabs
} from "@chakra-ui/react";
import {
  // colors, customEvent, HackleEventName,
  Spacing,
} from "goi_common";
// import { useRouter } from "next/router";
import { ParlorDetailProps } from "@/types/parlor";
import {
  Dispatch,
  SetStateAction,
  // useEffect, useState
} from "react";
import AmenityInfoTabPanel from "./AmenityInfoTabPanel";
import PriceInfoTabPanel from "./PriceInfoTabPanel";
// import ReviewInfoTabPanel from "./ReviewInfoTabPanel";
import ParlorRequestBox from "../ParlorRequestBox/ParlorRequestBox";
import PrepaidBanners from "@/components/common/PrepaidBanners";

// const TAB_NAME = ["price", "info", "review"];

function TabInfoSection({
  parlor,
  selectedSangjo,
  setSelectedSangjo,
  discountDescription,
  closestParlors,
  isExcluded,
}: {
  parlor: ParlorDetailProps;
  selectedSangjo: string;
  setSelectedSangjo: Dispatch<SetStateAction<string>>;
  discountDescription?: string;
  closestParlors: any;
  isExcluded?: boolean;
}) {
  // const [tabIndex, setTabIndex] = useState(0);
  // const router = useRouter();

  // useEffect(() => {
  //   const index = TAB_NAME.findIndex((name) => name === location.hash.slice(1));

  //   if (index >= 0) {
  //     setTabIndex(index);
  //   } else {
  //     setTabIndex(0);
  //   }
  // }, []);

  return (
    // <Tabs
    //   isFitted
    //   index={tabIndex}
    //   onChange={(index) => setTabIndex(index)}
    //   style={{ color: `${colors.gray500}`, borderColor: `${colors.gray300}` }}
    // >
    //   <TabList>
    //     <Tab
    //       style={{
    //         fontSize: "14px",
    //       }}
    //       onClick={() => {
    //         customEvent({
    //           newGtm: {
    //             path: "parlor_detail",
    //             trigger_and_target: "price-tab_price",
    //           },
    //           hackle: { key: HackleEventName["장례식장 상세 - 탭 비용 클릭"] },
    //         });
    //         router.replace("#price");
    //       }}
    //       _selected={{ color: `${colors.black}`, borderColor: `${colors.black}`, fontWeight: 700 }}
    //     >
    //       비용 / 정보
    //     </Tab>
    //     {/* <Tab
    //       style={{
    //         fontSize: "14px",
    //       }}
    //       onClick={() => {
    //         customEvent({
    //           newGtm: {
    //             path: "parlor_detail",
    //             trigger_and_target: "info-tab_info",
    //           },
    //           hackle: { key: HackleEventName["장례식장 상세 - 탭 정보 클릭"] },
    //         });
    //         router.replace("#info");
    //       }}
    //       _selected={{ color: `${colors.black}`, borderColor: `${colors.black}`, fontWeight: 700 }}
    //     >
    //       오시는길 / 시설안내
    //     </Tab> */}
    //   </TabList>
    //   <div style={{ marginTop: "16px" }} />
    //   <TabPanels>
    //     <TabPanel padding="0">
    //       {tabIndex === 0 && (
    <>
      <PriceInfoTabPanel
        isExcluded={isExcluded}
        // key={`tab-${tabIndex}`}
        expectedCharges={parlor.expected_charge_sum}
        binsos={parlor.binsos}
        services={parlor.services}
        parlor={parlor}
        selectedSangjo={selectedSangjo}
        setSelectedSangjo={setSelectedSangjo}
        discountDescription={discountDescription}
        closestParlors={closestParlors}
      />

      <Box width="100%" alignItems="center">
        {/* {variation === "A" && (
            <Box width="100%" alignItems="center">
              <Box width="100%" maxWidth="480px" padding="12px" margin="auto">
                <TotalPriceSection
                  expectedCharges={parlor.expected_charge_sum}
                  selectedSangjo="가족장"
                />
              </Box>
            </Box>
          )} */}
        {/* <Box>
            <TopBanner path="parlor_detail" />
          </Box> */}
        <Box width="100%" alignItems="center">
          <Box width="100%" maxWidth="480px" padding="12px" margin="auto">
            {/* <Spacing gap={40} /> */}
            <ParlorRequestBox
              sido={parlor.sido}
              sigungu={parlor.sigungu}
              companyName={parlor.companyname}
            />
          </Box>
        </Box>
      </Box>

      <PrepaidBanners
        isMobile
        title="장례 비용을 줄이시고 싶으시다면"
        extra="(장례식장 비용이 아닌 인력, 용품, 차량 패키지에 대해 적용)"
        eventPath="parlor_detail"
      />

      <AmenityInfoTabPanel parlor={parlor} />
      <Spacing gap={120} />
    </>
    //     </TabPanel>
    //     <TabPanel padding="0">{tabIndex === 1 && <AmenityInfoTabPanel parlor={parlor} />}</TabPanel>
    //     <TabPanel padding="0">{tabIndex === 2 && <ReviewInfoTabPanel parlor={parlor} />}</TabPanel>
    //   </TabPanels>
    // </Tabs>
  );
}

export default TabInfoSection;
